module.exports = require('./lib/client');



//////////////////
// WEBPACK FOOTER
// ./~/feathers-socketio/client.js
// module id = 601
// module chunks = 0